"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modalNeoDark = exports.modalNeoLight = exports.modalNovoDark = exports.modalNovo = exports.modal = void 0;
const polished_1 = require("polished");
const styled_components_1 = require("styled-components");
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const spacing_const_1 = __importDefault(require("../choices/spacing.const"));
const timing_const_1 = __importDefault(require("../choices/timing.const"));
const zIndex_const_1 = __importDefault(require("../choices/zIndex.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const { light, dark, neoLight, neoDark } = oxygen_theme_1.default;
const animation = (0, styled_components_1.keyframes) `
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  70% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;
const fadeInAnimation = (0, styled_components_1.css) `
  animation: ${animation} ${timing_const_1.default.medium} ease-in;
`;
const fadeInAnimationNovo = (0, styled_components_1.css) `
  animation: ${animation} 150ms ease-in;
`;
const modal = {
    zIndex: zIndex_const_1.default.z2000,
    widthSmall: '620px',
    width: '620px',
    widthLarge: '960px',
    minHeight: '360px',
    modalOffsetMinimal: spacing_const_1.default.md,
    backgroundColor: color_const_1.default.white,
    shadowSize: size_const_1.default.shadowMedium,
    shadowColor: (0, polished_1.rgba)(color_const_1.default.pickledBluewood800, 0.1),
    borderRadius: size_const_1.default.borderRadiusMedium,
    animation: fadeInAnimation,
    headerPadding: spacing_const_1.default.md,
    headerPaddingRightWithIcon: '56px',
    headerShadowSize: size_const_1.default.shadowSmall,
    headerShadowColor: color_const_1.default.cloudyBlue300,
    headerFontFamily: font_const_1.default.family,
    headerTitleFontSize: font_const_1.default.sizeLg,
    headerTitleLineHeight: font_const_1.default.lineHeightLg,
    headerTitleFontWeight: font_const_1.default.weightAttention,
    headerTitleFontLetterSpacing: 'normal',
    headerTitleColor: undefined,
    headerTitleWrap: true,
    headerIconTop: spacing_const_1.default.md,
    headerIconRight: spacing_const_1.default.md,
    headerIconColor: color_const_1.default.steel700,
    headerIconColorActive: color_const_1.default.dodgerBlue,
    headerIconColorFocus: color_const_1.default.dodgerBlue,
    headerIconColorHover: color_const_1.default.dodgerBlue,
    headerIconBackgroundActive: 'transparent',
    headerIconBackgroundFocus: 'transparent',
    headerIconBackgroundHover: 'transparent',
    headerIconBorderFocus: 'transparent',
    contentColor: undefined,
    contentPadding: spacing_const_1.default.md,
    contentFontFamily: font_const_1.default.family,
    contentFontSize: font_const_1.default.sizeSm,
    contentLineHeight: font_const_1.default.lineHeightSm,
    contentFontWeight: font_const_1.default.weightDefault,
    contentFontLetterSpacing: 'normal',
    footerPaddingHorizontal: size_const_1.default.medium,
    footerPaddingSmallHorizontal: size_const_1.default.default2x,
    footerPaddingVertical: size_const_1.default.default2x,
    footerShadowSize: size_const_1.default.shadowSmall,
    footerShadowColor: color_const_1.default.cloudyBlue300,
    footerButtonSpacing: spacing_const_1.default.md,
};
exports.modal = modal;
const modalNovo = {
    animation: fadeInAnimationNovo,
    backgroundColor: light.ui06,
    borderRadius: '6px',
    modalOffsetMinimal: light.spacing07,
    shadowColor: (0, polished_1.rgba)(light.shadow01, 0.25),
    shadowSize: '0 6px 20px',
    minHeight: '0',
    width: '436px',
    widthLarge: '664px',
    widthSmall: '320px',
    zIndex: zIndex_const_1.default.z2000,
    headerPadding: `${light.spacing05}`,
    headerPaddingNoContent: `${light.spacing05}`,
    headerPaddingRightWithIcon: light.spacing09,
    headerShadowSize: '0 1px 0 0',
    headerShadowColor: light.ui02,
    headerFontFamily: light.heading01.fontFamily,
    headerTitleColor: light.textColor01,
    headerTitleFontSize: light.heading01.fontSize,
    headerTitleFontWeight: light.heading01.fontWeight,
    headerTitleFontLetterSpacing: light.heading01.letterSpacing,
    headerTitleLineHeight: light.heading01.lineHeight,
    headerTitleWrap: false,
    headerIconTop: '34px',
    headerIconRight: light.spacing05,
    headerIconColor: light.icon01,
    headerIconColorActive: light.icon01,
    headerIconColorFocus: light.icon01,
    headerIconColorHover: light.icon01,
    headerIconBackgroundActive: light.active05,
    headerIconBackgroundFocus: 'transparent',
    headerIconBackgroundHover: light.hover05,
    headerIconBorderFocus: light.focus01,
    contentColor: light.textColor01,
    contentFontFamily: light.body01.fontFamily,
    contentFontLetterSpacing: light.body01.letterSpacing,
    contentFontSize: light.body01.fontSize,
    contentFontWeight: light.body01.fontWeight,
    contentLineHeight: light.body01.lineHeight,
    contentPadding: `0 ${light.spacing05}`,
    footerPadding: `${light.spacing05}`,
    footerPaddingSmall: `${light.spacing05}`,
    footerPaddingNoContent: `${light.spacing05}`,
    footerButtonSpacing: light.spacing03,
    footerShadowSize: '0 1px 0 0',
    footerShadowColor: light.ui02,
};
exports.modalNovo = modalNovo;
const modalNovoDark = {
    ...modalNovo,
    backgroundColor: dark.ui06,
    shadowColor: (0, polished_1.rgba)(dark.shadow01, 0.25),
    headerShadowColor: dark.ui02,
    headerTitleColor: dark.textColor01,
    headerIconColor: dark.icon01,
    headerIconColorActive: dark.icon01,
    headerIconColorFocus: dark.icon01,
    headerIconColorHover: dark.icon01,
    headerIconBackgroundActive: dark.active05,
    headerIconBackgroundFocus: 'transparent',
    headerIconBackgroundHover: dark.hover05,
    headerIconBorderFocus: dark.focus01,
    contentColor: dark.textColor01,
    footerShadowColor: dark.ui02,
};
exports.modalNovoDark = modalNovoDark;
const modalNeoLight = {
    ...modalNovo,
    backgroundColor: neoLight.ui06,
    shadowColor: (0, polished_1.rgba)(neoLight.shadow01, 0.25),
    headerShadowColor: neoLight.ui02,
    headerTitleColor: neoLight.textColor01,
    headerIconColor: neoLight.icon01,
    headerIconColorActive: neoLight.icon01,
    headerIconColorFocus: neoLight.icon01,
    headerIconColorHover: neoLight.icon01,
    headerIconBackgroundActive: neoLight.active05,
    headerIconBackgroundHover: neoLight.hover05,
    headerIconBorderFocus: neoLight.focus01,
    contentColor: neoLight.textColor01,
    footerShadowColor: neoLight.ui02,
};
exports.modalNeoLight = modalNeoLight;
const modalNeoDark = {
    ...modalNovoDark,
    backgroundColor: neoDark.ui06,
    shadowColor: (0, polished_1.rgba)(neoDark.shadow01, 0.25),
    headerShadowColor: neoDark.ui02,
    headerTitleColor: neoDark.textColor01,
    headerIconColor: neoDark.icon01,
    headerIconColorActive: neoDark.icon01,
    headerIconColorFocus: neoDark.icon01,
    headerIconColorHover: neoDark.icon01,
    headerIconBackgroundActive: neoDark.active05,
    headerIconBackgroundHover: neoDark.hover05,
    headerIconBorderFocus: neoDark.focus01,
    contentColor: neoDark.textColor01,
    footerShadowColor: neoDark.ui02,
};
exports.modalNeoDark = modalNeoDark;
